import React from 'react'

export class Home extends React.Component {

  render() {
      return (
          <div>Administración rancholasardillas.com</div>
      );
  }
}